<script setup lang="ts">
import { ref } from "vue";

const STORAGE_KEY = "service-end-notice-hidden-until";
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const NEXT_SERVICE_URL = "http://ac.red.susimdal.com/";

const isHiddenForToday = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return false;

        const hiddenUntil = Number(stored);
        if (!Number.isFinite(hiddenUntil) || Date.now() >= hiddenUntil) {
            localStorage.removeItem(STORAGE_KEY);
            return false;
        }

        return true;
    } catch {
        return false;
    }
};

const isOpen = ref(!isHiddenForToday());

const close = () => {
    isOpen.value = false;
};

const hideForOneDay = () => {
    try {
        localStorage.setItem(STORAGE_KEY, String(Date.now() + ONE_DAY_MS));
    } catch {
        // 저장에 실패해도 이번 화면에서는 닫습니다.
    }
    isOpen.value = false;
};

const openNextService = () => {
    window.open(NEXT_SERVICE_URL, "_blank", "noopener,noreferrer");
};
</script>

<template>
    <Teleport to="body">
        <div
            v-if="isOpen"
            class="fixed inset-0 z-[10000] flex items-center justify-center bg-primary-black/30 px-[2rem]"
            role="dialog"
            aria-modal="true"
            aria-labelledby="service-end-notice-title"
        >
            <div
                class="flex w-full max-w-[48rem] flex-col gap-[2.4rem] rounded-[1.6rem] bg-white px-[2.8rem] py-[2.8rem] shadow-lg"
            >
                <div class="flex flex-col gap-[1.2rem]">
                    <h2
                        id="service-end-notice-title"
                        class="text-center text-lg font-semibold font-pretended text-primary-black"
                    >
                        서비스 종료 안내
                    </h2>
                    <p
                        class="text-center text-base font-medium leading-[1.6] font-pretended text-primary-black whitespace-pre-wrap"
                    >
                        현재 서비스는 2026년 11월 1일부로 종료됩니다.
                        <button
                            type="button"
                            class="text-primary-blue underline underline-offset-2 cursor-pointer"
                            @click="openNextService"
                        >
                            {{ NEXT_SERVICE_URL }}
                        </button>
                        을 이용해주세요
                    </p>
                </div>
                <div class="flex items-center justify-end gap-[1.2rem]">
                    <button
                        type="button"
                        class="cursor-pointer px-[0.4rem] py-[1rem] text-base font-medium font-pretended text-primary-gray underline underline-offset-2"
                        @click="hideForOneDay"
                    >
                        하루동안 보지않기
                    </button>
                    <button
                        type="button"
                        class="cursor-pointer rounded-[0.8rem] bg-primary-red px-[2rem] py-[1rem] text-base font-medium font-pretended text-white"
                        @click="close"
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    </Teleport>
</template>
